import { VantageNames } from '@/vantage/constants';
import { SeeqNames } from '@seeqdev/constants';

export const VIRTUAL_COLUMN_TYPE_VANTAGE = 'vantage' as const;
export type VirtualColumnType = typeof VIRTUAL_COLUMN_TYPE_VANTAGE;

/** Grouping for table data */
export interface GroupBy {
  /** Columns to group by */
  rowGroupColumnIds: string[];
  /** Columns to aggregate on */
  valueColumns: { columnId: string; aggregationFunction?: string }[];
  /** Expanded group nodes. A `null` entry represents the blank/null group at that level. */
  groupKeys: (string | null)[];
}

/**
 * Sentinel used in row data and AG Grid group keys to represent a blank/null value
 * for a row-group column. AG Grid SSRM drops null `node.key`s, so we substitute
 * this sentinel into row data before AG Grid sees it, and translate it back to
 * `null` when shipping `groupKeys` to the backend.
 */
export const BLANK_GROUP_KEY = '__SEEQ_BLANK_GROUP__';

export const VANTAGE_COLUMN_KEY_TO_TABLE_COLUMN_MAP = {
  [`${VantageNames.Columns.Condition}*`]: VantageNames.Columns.Condition,
  [VantageNames.Columns.ConditionID]: SeeqNames.MaterializedTables.ItemIdColumn,
  [VantageNames.Columns.TimeCreated]: SeeqNames.MaterializedTables.CreatedAtColumn,
  [VantageNames.Columns.TimeUpdated]: SeeqNames.Properties.UpdatedAt,
};

export const VANTAGE_GROUPING_COLUMN_KEY_TO_TABLE_COLUMN_MAP = {
  [`${VantageNames.Columns.Condition}*`]: SeeqNames.MaterializedTables.ItemIdColumn,
};

/**
 * The maximum number of distinct values to fetch for a column when populating filter options.
 * A conservative limit is set to avoid performance issues with large datasets.
 */
export const SET_OPTIONS_FETCH_LIMIT = 100;
